export function getFileExtension(file: File): string | null {
  const name = file.name;
  const lastDotIndex = name.lastIndexOf('.');

  if (lastDotIndex === -1 || lastDotIndex === name.length - 1) {
    return null; // No extension or ends with a dot
  }

  return name.substr(lastDotIndex + 1);
}

export function getFileExtensionByName(filename: string): string | null {
  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
    return null; // No extension or ends with a dot
  }

  return filename.substring(lastDotIndex + 1);
}

export function getFileExtensionByUrl(url: string): string | null {
  const urlPath = url.split('?')[0];
  const lastSlashIndex = urlPath.lastIndexOf('/');
  if (lastSlashIndex === -1) {
    return null; // No file name found
  }
  const filename = urlPath.substring(lastSlashIndex + 1);
  return getFileExtensionByName(filename);
}
